import { useState } from "react";
import { toast } from "sonner";
import { fetchEnquiries } from "../lib/api";
import { waLink } from "../data/business";
import { WhatsAppIcon } from "../components/WhatsAppIcon";

export default function Admin() {
  const [key, setKey] = useState("");
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { setRows(await fetchEnquiries(key)); }
    catch { toast.error("Invalid admin key"); }
    finally { setLoading(false); }
  };

  return (
    <main data-testid="admin-page" className="pt-[72px] min-h-screen">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-20">
        <p className="eyebrow mb-4">Admin</p>
        <h1 className="font-display font-light text-ivory text-4xl sm:text-5xl lg:text-6xl">Enquiries</h1>

        {!rows ? (
          <form onSubmit={load} className="mt-10 flex flex-wrap gap-3 max-w-md" data-testid="admin-login-form">
            <input type="password" data-testid="admin-key-input" className="field flex-1" placeholder="Admin key" value={key} onChange={(e) => setKey(e.target.value)} />
            <button data-testid="admin-login-btn" className="btn-gold" disabled={loading}>{loading ? "…" : "Open"}</button>
          </form>
        ) : (
          <div className="mt-10 overflow-x-auto border border-gold/20" data-testid="admin-table">
            <table className="w-full text-sm">
              <thead className="bg-gold/5 text-[10px] uppercase tracking-[0.25em] text-gold">
                <tr>{["When", "Name", "Phone", "Type", "Spec", "Qty ct", "Lot", "Message", ""].map((h) => <th key={h} className="text-left px-4 py-3 font-medium">{h}</th>)}</tr>
              </thead>
              <tbody>
                {rows.length === 0 && <tr><td colSpan={9} className="px-4 py-10 text-center text-ivory/50" data-testid="admin-empty">No enquiries yet</td></tr>}
                {rows.map((r) => (
                  <tr key={r.id} data-testid={`admin-row-${r.id}`} className="border-t border-gold/10 text-ivory/80 align-top">
                    <td className="px-4 py-3 whitespace-nowrap text-xs text-ivory/50">{new Date(r.created_at).toLocaleString("en-IN")}</td>
                    <td className="px-4 py-3 text-ivory">{r.name}</td>
                    <td className="px-4 py-3 whitespace-nowrap">{r.phone}</td>
                    <td className="px-4 py-3"><span className="px-2 py-0.5 border border-gold/30 text-[10px] tracking-widest text-saffron">{r.buyer_type}</span></td>
                    <td className="px-4 py-3 text-xs">{[r.shape, r.sieve, r.clarity, r.carat_range].filter(Boolean).join(" · ") || "—"}</td>
                    <td className="px-4 py-3">{r.quantity_carats ?? "—"}</td>
                    <td className="px-4 py-3 font-mono text-xs">{r.lot_id || "—"}</td>
                    <td className="px-4 py-3 text-xs max-w-[240px]">{r.message || "—"}</td>
                    <td className="px-4 py-3"><a className="text-saffron text-xs uppercase tracking-widest hover:text-ivory" href={`https://wa.me/${r.phone.replace(/\D/g, "")}`} target="_blank" rel="noreferrer">Reply</a></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {rows && <p className="mt-4 text-xs text-ivory/40" data-testid="admin-count">{rows.length} enquiries · <a className="hover:text-saffron inline-flex items-center gap-1" href={waLink("")} target="_blank" rel="noreferrer">business <WhatsAppIcon size={12} className="text-[#25D366]" /></a></p>}
      </div>
    </main>
  );
}
